
<div id="suppliers">
    <div class="row action-bar">
        <div class="col col-12 col-xxxxl-6">
            <b-input-group class="filter-input">
                <template #prepend>
                    <b-input-group-text>
                        <b-icon-search />
                    </b-input-group-text>
                </template>
                <b-input
                    v-model="filter.q"
                    :debounce="filterDebounce"
                    :placeholder="$t('overview.suppliers.table.search.placeholder')"
                />
            </b-input-group>
        </div>

        <div class="col col-12 col-xxxxl-6">
            <div class="filter" @click="filterExpanded = !filterExpanded">
                <small>
                    <span class="text-muted">{{ $t("overview.suppliers.table.filter.label") }}</span>
                </small>
                <AnimatedCaret :expanded="filterExpanded" />
            </div>

            <b-dropdown
                no-caret
                right
                size="md"
                toggle-tag="div"
                class="ordering"
                @show="orderingExpanded = true"
                @hide="orderingExpanded = false"
            >
                <template v-slot:button-content>
                    <small>
                        <span class="text-muted">{{ $t("ordering.label") }}: </span>
                        <span class="bold">{{ selectedSortOption.text }}</span>
                    </small>
                    <AnimatedCaret :expanded="orderingExpanded" />
                </template>

                <b-dropdown-item
                    v-for="(n, i) in sortOptions"
                    class="dropdown-link"
                    :key="'opt-sort-' + i"
                    :active="selectedSortOptionValue == i"
                    @click="selectedSortOptionValue = i"
                    >
                    {{ n.text }}
                </b-dropdown-item>
            </b-dropdown>

            <b-dropdown
                no-caret
                right
                size="md"
                toggle-tag="div"
                class="fields"
                @show="fieldsExpanded = true"
                @hide="fieldsExpanded = false"
            >
                <template v-slot:button-content>
                    <small>
                        <span class="text-muted">{{ $t("overview.suppliers.table.fields.label") }}</span>
                    </small>
                    <AnimatedCaret :expanded="fieldsExpanded" />
                </template>
                <b-dropdown-form
                    v-for="(n, i) in fieldsOptions"
                    :key="'opt-field-' + i+1"
                    @click.prevent="toggleField(n)"
                >
                    <div class="d-flex justify-content-between">
                        {{ n.label }}&nbsp;
                        <b-form-checkbox
                            v-model="n.isActive"
                            :disabled="!isFieldEnabled(n)"
                            switch
                            class="d-inline-block ml-3"
                        />
                    </div>
                </b-dropdown-form>
            </b-dropdown>
            <template v-if="showTreeMap">
                 <b-button v-on:click="showTreeMap=!showTreeMap" class="treemap-btn">
                    <small>
                        <b-icon icon="eye-slash" font-scale="1" style=""/>
                        <span> {{$t('overview.tenders.table.treemap.hide')}}</span>
                    </small>
                </b-button>
            </template>
            <template v-else >
                <b-button v-on:click="showTreeMap=!showTreeMap" class="treemap-btn">
                    <small>
                        <b-icon icon="eye" font-scale="1" style=""/>
                        <span> {{$t('overview.tenders.table.treemap.show')}}</span>
                    </small>
                </b-button>
            </template>
        </div>
    </div>

    <div v-show="filterExpanded" class="other-filters mb-5">
        <div class="row text-left">
            <div class="col-12 col-xl-6 mb-3 mb-xl-0">
                <h5>
                    {{ $t("overview.suppliers.table.filter.flags.label") }}
                </h5>

                <MultiselectFilter 
                    :type="'supplier'"
                    :version="version"
                    :hash="hash"
                    @flags="(flags) => {filter.flag = flags}"
                >
                    <template #option="props">
                        <template v-if="props.option.$isLabel">
                            <strong>{{ props.option.$groupLabel }}</strong>
                        </template>
                        <template v-else>
                            <div class="d-flex justify-content-between">
                                <span>{{ props.option.name }}</span>
                                <span class="text-muted text-right ml-4">{{ props.option.count }}</span>
                            </div>
                        </template>
                    </template>
                </MultiselectFilter>
            </div>

            <div class="col-6 col-xl-3">
                <h5>{{ $t("overview.suppliers.table.head.risk") }}</h5>
                <b-form-checkbox-group stacked v-model="filter.risk">
                    <b-form-checkbox value="high">
                        <RiskLevelDumpling level="high" />
                        &nbsp;{{ $t("risk.levelFull.high") }}
                    </b-form-checkbox>
                    <b-form-checkbox value="medium">
                        <RiskLevelDumpling level="medium" />
                        &nbsp;{{ $t("risk.levelFull.medium") }}
                    </b-form-checkbox>
                    <b-form-checkbox value="low">
                        <RiskLevelDumpling level="low" />
                        &nbsp;{{ $t("risk.levelFull.low") }}
                    </b-form-checkbox>
                    <b-form-checkbox value="no_risk">
                        <RiskLevelDumpling level="no" />
                        &nbsp;{{ $t("risk.levelFull.no") }}
                    </b-form-checkbox>
                </b-form-checkbox-group>
            </div>

            <div class="col-6 col-xl-3">
                <h5>
                    {{ $t("overview.suppliers.table.filter.date.label") }}
                </h5>

                <b-form-group>
                    <b-form-checkbox-group v-model="filter.year" stacked>
                        <div class="row justify-content-between">
                            <template
                                v-for="(g, i) in chunk(
                                    range(analysis.suppliers_min_year, analysis.suppliers_max_year),
                                    4
                                )"
                            >
                                <div :key="`group-${i}`" class="col">
                                    <b-form-checkbox v-for="y in g" :key="y" :value="y">{{ y }}</b-form-checkbox>
                                </div>
                            </template>
                        </div>
                    </b-form-checkbox-group>
                </b-form-group>
            </div>
        </div>
    </div>


    <TreeMap 
        ref="tree_map_data_table" 
        :version="version" 
        :title="$t('overview.suppliers.table.treemap.title')" 
        :show="showTreeMap" 
        :hash="hash" 
        :type="'suppliers'" 
        :filter="filter" 
        :url_type="'supplier'"
        :order="selectedSortOption"
    />
    <DataTable
        id="suppliers-data-table"
        v-bind="tableSettings"
        :sort-by.sync="selectedSortOption.value.by"
        :sort-desc.sync="selectedSortOption.value.desc"
        :per-page="perPage"
        :start-page="startPage"
        @row-clicked="(item) => $router.push(getSupplierRoute(item))"
        @row-contextmenu="(item, index, event) => {
            event.preventDefault()
            $root.$emit('navigationContextMenu', {event: event, routerArguments: getSupplierRoute(item)})
        }"
        ref="suppliers_data_table"
    >
        <template v-slot:cell(total_sum)="data">
            <span class="numeric">{{ formatNumber(data.item.total_sum) }}</span>
        </template>

        <template v-slot:cell(accounting_payments)="data">
            <span class="numeric">{{ formatNumber(data.item.accounting_payments) }}</span>
        </template>

        <template v-slot:cell(risk)="data">
            <RiskLevelDumpling :value="data.item.risk" :level="versionRiskLevel(data.item, version)" />
        </template>
    </DataTable>
</div>
